import { ref } from 'vue'
import { useJsonErrorParser } from '@jinkosoft/json-error-parser'

export function useNormalizedGraphQLValidationErrors(input = {}) {
    const {
        errorsFormat = 'json',
    } = input

    const { parseError } = useJsonErrorParser()

    const errors = ref({})
    const rawErrors = ref({})

    const reset = () => {
        errors.value = {}
        rawErrors.value = {}
    }

    const isValidationError = (error) => {
        return !!error?.graphQLErrors?.[0]?.extensions?.validation
    }

    const normalizeMessage = (message) => {
        if (!message) return []

        if (typeof message === 'string') {
            return [message]
        }

        if (Array.isArray(message)) {
            return message.flatMap(normalizeMessage)
        }

        if (typeof message === 'object' && message.message) {
            return [parseError(message)]
        }

        return []
    }

    const normalizeMessages = (messages) => {
        if (errorsFormat !== 'json') {
            return messages
        }

        return normalizeMessage(messages)
    }

    const setNestedError = (obj, path, messages) => {
        const keys = path.split('.')
        let current = obj

        keys.forEach((key, index) => {
            if (index === keys.length - 1) {
                current[key] = normalizeMessages(messages)
                return
            }

            if (!current[key]) {
                current[key] = {}
            }

            current = current[key]
        })
    }

    const parseValidation = (error) => {
        rawErrors.value = error?.graphQLErrors?.[0]?.extensions?.validation ?? {}

        Object.entries(rawErrors.value).forEach(([key, messages]) => {
            setNestedError(errors.value, key.replace(/^.*?\./, ''), messages)
        })
    }

    const hasErrors = () => {
        return Object.keys(errors.value).length > 0
    }

    const getCreateRelationErrors = (errors, index) => {
        return errors?.create[index]
    }

    const getUpdateRelationErrors = (errors, relation, item, cmpField = 'id') => {
        if (errors?.update) {
            for (const [index, itemErrors] of Object.entries(errors?.update)) {
                if (item[cmpField] === relation.update[index][cmpField]) {
                    return itemErrors
                }
            }
        }

        return null
    }

    const getRelationErrors = (mode, errors, relation, item, index, cmpField = 'id') => {
        if (mode === 'create') {
            return getCreateRelationErrors(errors, index)
        }

        if (mode === 'update') {
            return getUpdateRelationErrors(errors, relation, item, cmpField)
        }
    }

    return {
        errors,
        rawErrors,

        reset,
        isValidationError,
        parseValidation,
        hasErrors,

        getCreateRelationErrors,
        getUpdateRelationErrors,

        getRelationErrors,
    }
}
